// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Components
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { BaseLayoutAppBar, BaseLayoutContent } from 'components/Layout/BaseLayout'
import Logo from 'components/Layout/Logo'
import Menu from 'atoms/Menu'
import { LinkMenuItem, LinkButton } from 'atoms/Link'

// Icons
import MoreVertIcon from '@material-ui/icons/MoreVert'

// Styles
const styles = theme => ({
  desktopMenu: {
    '& > *:not(:last-child)': {
      marginRight: theme.spacing.unit * 2
    }
  },
  mobileMenuButton: {
    marginRight: -theme.spacing.unit * 2
  },
  appBarContentGrow: {
    flex: 1
  }
})

export default
@withStyles(styles)
class GuestLayout extends Component {
  static propTypes = {
    children: PropTypes.any,
    classes: PropTypes.object.isRequired,
  }

  state = {
    mobileMenuAnchorEl: undefined,
    mobileMenuOpen: false
  }

  getMenuItems() {
    return [
      { to: '/login', label: 'Sign in' },
      { to: '/signup', label: 'Sign up' },
    ]
  }

  handleMobileMenuClick = (ev) => {
    this.setState({
      mobileMenuAnchorEl: ev.currentTarget,
      mobileMenuOpen: true
    })
  }

  handleMobileMenuClose = () => {
    this.setState({ mobileMenuOpen: false })
  }

  renderDesktopMenu() {
    const { classes } = this.props
    return (
      <nav className={classes.desktopMenu}>
        { this.getMenuItems().map(({ label, ...rest }, index) => (
          // eslint-disable-next-line
          <LinkButton key={index} size="small" {...rest}>
            { label }
          </LinkButton>
        )) }
      </nav>
    )
  }

  renderMobileMenu() {
    const { classes } = this.props
    const { mobileMenuOpen, mobileMenuAnchorEl } = this.state
    return (
      <nav>
        <IconButton
          className={classes.mobileMenuButton}
          onClick={this.handleMobileMenuClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          open={mobileMenuOpen}
          anchorEl={mobileMenuAnchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          getContentAnchorEl={undefined}
          onClose={this.handleMobileMenuClose}
        >
          { this.getMenuItems().map(({ label, ...rest }) => (
            <LinkMenuItem
              key={rest.to}
              {...rest}
              onClick={this.handleMobileMenuClose}
            >
              <Typography>{ label }</Typography>
            </LinkMenuItem>
          )) }
        </Menu>
      </nav>
    )
  }

  render() {
    const { children, classes } = this.props
    return (
      <Fragment>
        <BaseLayoutAppBar>
          <div className={classes.appBarContentGrow}>
            <Logo largeOnDesktop />
          </div>
          <Hidden xsDown>
            { this.renderDesktopMenu() }
          </Hidden>
          <Hidden smUp>
            { this.renderMobileMenu() }
          </Hidden>
        </BaseLayoutAppBar>
        <BaseLayoutContent>
          { children }
        </BaseLayoutContent>
      </Fragment>
    )
  }
}
